import LocalStorage from './LocalStorage';
import { IRequestError } from './RequestManager';
import RequestResponse from './RequestResponse';
import Config from './Config';
import PropApiRequest from './PropApiRequest';
import { RecursivePartial } from '../interfaces/TypeHelper';
import { IPersonFields } from '../components/FinancialCheck/BaufiImplecoLeadPage';
import { IProperty, IPropertyTypeHouse } from './JsonApiRequest';

/**
 * LeadSmart API Specification: https://ampr.stoplight.io/docs/leadsmart-public-api
 */

const BASE_URL = Config.get('baseUrl').replace(/\/$/, '') as string; // without trailing slash
const useProxy = true;
const isTestModus = Config.get('environment') !== 'prod';
const API_URL = useProxy ? BASE_URL + '/prop-api/leadsmart' : 'https://api.homecloud.de';
const CREDENTIALS_URL = BASE_URL + '/prop-api/leadsmart/credentials';

interface ILeadTokenResponse {
    access_token: string;
    expires_in: number;
}


export interface ILeadConsumer {
    campaignId: string;
    rank: number;
    companyName: string;
    groupId: string;
    companyWebsite: string;
    dataPrivacyUrl: string;
    displayName: string;
    publicDescription: string;
}

interface IPreflightResponse {
    leadConsumers: Array<ILeadConsumer>
}

// const leadData ={
//     "chosenLeadCampaignId": "ampr:campaign:wOkYqV6G8w2g5QcNodEWcS",
//     "externalHomeId": "FIO-1234567890",
//     "campaign": "Wohnglueck-Exposee-Anfrage",
//     "keyword": "Wohnglueck-Finanzierungscheck-JetztPersoenlicheRateBerechnen",
//     "dataContext": "TEST",
//     "source": "Impleco Wohnglück",
//     "trackingId": "WGL-471147114711",
//     "type": "BUYER_LEAD",
//     "firstPerson": {
//         "firstName": "Sabine",
//         "lastName": "Sonnenschein",
//         "email": "s-tokh@outlook.com",
//         "birthday": "1989-03-31",
//         "employedSince": "2020-03-31",
//         "monthlyNetIncomeInEuro": 3000
//     },
//     "household": {
//         "remainingDebtTotalInEuro": 0,
//         "equityTotalInEuro": 150000
//     },
//     "legal": {
//         "isHomecloudTermsChecked": true,
//         "homecloudTermsWording": "Ich stimme dem Finanzierungscheck gemäß den Homecloud AGB und der Übermittlung des Ergebnisses und meiner Daten an den Immobilienmakler zu.",
//         "hasReceivedHomecloudDataPrivacyNotes": true,
//         "homecloudDataPrivacyNotesWording": "Die Homecloud Datenschutzhinweise findest du hier und die Datenschutzhinweise unseres Finanzierungspartners hier.",
//         "hasReceivedPartnerDataPrivacyNotes": true,
//         "partnerDataPrivacyNotesWording": "Die Homecloud Datenschutzhinweise findest du hier und die Datenschutzhinweise unseres Finanzierungspartners hier.",
//         "isRealEstateDataForwardingChecked": true,
//         "realEstateDataForwardingWording": "Ich stimme dem Finanzierungscheck gemäß den Homecloud AGB und der Übermittlung des Ergebnisses und meiner Daten an den Immobilienmakler zu.",
//         "isMortgageAdvisorDataForwardingChecked": false,
//         "mortgageAdvisorDataForwardingWording": "Ich möchte eine persönliche Beratung zum Ergebnis meines Finanzierungschecks und stimme der Übermittlung meiner Daten und der Kontaktierung per E-Mail durch einen Finanzierungsprofi zu.",
//         "isMortgageAdvisoryWanted": false,
//         "isContactByPhoneWanted": true,
//         "contactByPhoneConsentWording": "Ich möchte eine persönliche Beratung zum Ergebnis meines Finanzierungschecks und stimme der Übermittlung meiner Daten und der Kontaktierung per E-Mail oder Telefon durch einen Finanzierungsprofi zu.",
//         "isContactByEmailWanted": true,
//         "contactByEmailConsentWording": "Ich möchte eine persönliche Beratung zum Ergebnis meines Finanzierungschecks und stimme der Übermittlung meiner Daten und der Kontaktierung per E-Mail oder Telefon durch einen Finanzierungsprofi zu.",
//         "userAuthenticationType": "ACCOUNT",
//         "userConsentType": "CHECKBOX"
//     }
// }

// const leadSmartExampleResponse = {
//     "campaign": "Wohnglueck-Exposee-Anfrage",
//     "chosenLeadCampaignId": "ampr:campaign:wOkYqV6G8w2g5QcNodEWcS",
//     "consumerInterface": {
//         "name": "Finn"
//     },
//     "createdAt": "2023-10-27T14:21:23.074Z",
//     "dataContext": "TEST",
//     "externalHomeId": "FIO-1234567890",
//     "homeId": "ampr:home:fxfpajiNThCvXGZcBFgJX8",
//     "id": "ampr:lead:Pua3v59PQkxAsLZW7NTHxM",
//     "keyword": "Wohnglueck-Finanzierungscheck-JetztPersoenlicheRateBerechnen",
//     "leadConsumerGroupId": "ampr:group:RjLtHL5ODhRelZORiAzzjj",
//     "leadProviderGroupId": "ampr:group:uPX4kuSa5zxUSvC2IkS1na",
//     "legal": {
//         "contactByEmailConsentWording": "Ich möchte eine persönliche Beratung zum Ergebnis meines Finanzierungschecks und stimme der Übermittlung meiner Daten und der Kontaktierung per E-Mail durch einen Finanzierungsprofi zu.",
//         "contactByPhoneConsentWording": "Ich möchte eine persönliche Beratung zum Ergebnis meines Finanzierungschecks und stimme der Übermittlung meiner Daten und der Kontaktierung per E-Mail durch einen Finanzierungsprofi zu.",
//         "dataProcessingAsDataProcessorAt": "2023-10-27T14:21:23.075Z",
//         "hasAccessToHomeDetails": false,
//         "hasReceivedHomecloudDataPrivacyNotes": true,
//         "hasReceivedPartnerDataPrivacyNotes": true,
//         "hasSignedBrokerageContract": false,
//         "homecloudDataPrivacyNotesWording": "Ich stimme dem Finanzierungscheck gemäß den Homecloud AGB und der Übermittlung des Ergebnisses und meiner Daten an den Immobilienmakler zu.*",
//         "homecloudTermsCheckedAt": "2023-10-27T14:21:23.075Z",
//         "homecloudTermsWording": "Ich stimme dem Finanzierungscheck gemäß den Homecloud AGB und der Übermittlung des Ergebnisses und meiner Daten an den Immobilienmakler zu.*",
//         "isContactByPhoneWanted": false,
//         "isDataProcessingAsDataProcessor": true,
//         "isHomecloudTermsChecked": true,
//         "isMortgageAdvisorDataForwardingChecked": false,
//         "isRealEstateDataForwardingChecked": true,
//         "mortgageAdvisorDataForwardingWording": "Ich möchte eine persönliche Beratung zum Ergebnis meines Finanzierungschecks und stimme der Übermittlung meiner Daten und der Kontaktierung per E-Mail durch einen Finanzierungsprofi zu.",
//         "partnerDataPrivacyNotesWording": "Ich stimme dem Finanzierungscheck gemäß den Homecloud AGB und der Übermittlung des Ergebnisses und meiner Daten an den Immobilienmakler zu.*",
//         "realEstateDataForwardingCheckedAt": "2023-10-27T14:21:23.075Z",
//         "realEstateDataForwardingWording": "Ich stimme dem Finanzierungscheck gemäß den Homecloud AGB und der Übermittlung des Ergebnisses und meiner Daten an den Immobilienmakler zu.*",
//         "receivedHomecloudDataPrivacyNotesAt": "2023-10-27T14:21:23.075Z",
//         "receivedPartnerDataPrivacyNotesAt": "2023-10-27T14:21:23.075Z"
//     },
//     "mortgage": {
//         "displayConditions": {
//             "fixedInterestPeriodInYears": 15,
//             "fixedInterestRateInPercent": 4.25,
//             "monthlyPaymentInEuro": 1426.25,
//             "effectiveInterestRateInPercent": 4.36
//         },
//         "oneclick": {
//             "isOneClickQualified": true
//         }
//     },
//     "scoring": {
//         "closingProbabilityScoreAsGrade": "D",
//         "feasibilityScore": 96,
//         "feasibilityScoreAsGrade": "A",
//         "maximumOfferInEuro": 375000
//     },
//     "source": "Impleco Wohnglück",
//     "trackingId": "1698416482229",
//     "type": "BUYER_LEAD",
//     "updatedAt": "2023-10-27T14:21:23.075Z"
// }

interface ILeadAddress {
    street: string,
    houseNumber: string,
    postalCode: string,
    city: string,
    state: string
}

interface ILeadPerson {
    firstName: string;
    lastName: string;
    email: string;
    birthday: string;
    employedSince: string;
    monthlyNetIncomeInEuro: number;
    additionalMonthlyIncome: number;
    address: Partial<ILeadAddress>;
    employmentType: 'EMPLOYEE' | 'PUBLIC_SERVANT' | 'FREELANCER' | 'SELF_EMPLOYED' | 'UNEMPLOYED' | 'WORKER' | 'STAY_AT_HOME_PARTNER' | 'RETIREE';
}

export interface ILeadData {
    chosenLeadCampaignId: string;
    externalHomeId?: string;
    campaign: string;
    keyword: string;
    dataContext: 'REAL' | 'TEST';
    source: string;
    trackingId: string;
    type: 'BUYER_LEAD' | 'MORTGAGE_LEAD';
    subtype: 'PURCHASE';
    firstPerson: ILeadPerson;
    secondPerson: ILeadPerson;
    household: {
        remainingDebtTotalInEuro: number;
        equityTotalInEuro: number;
    };
    legal: {
        isHomecloudTermsChecked?: boolean;
        homecloudTermsWording?: string;
        hasReceivedHomecloudDataPrivacyNotes?: boolean;
        homecloudDataPrivacyNotesWording?: string;
        hasReceivedPartnerDataPrivacyNotes?: boolean;
        partnerDataPrivacyNotesWording?: string;
        isRealEstateDataForwardingChecked?: boolean;
        realEstateDataForwardingWording?: string;
        isMortgageAdvisorDataForwardingChecked?: boolean;
        mortgageAdvisorDataForwardingWording?: string;
        isMortgageAdvisoryWanted?: boolean;
        isContactByPhoneWanted?: boolean;
        contactByPhoneConsentWording?: string;
        isContactByEmailWanted?: boolean;
        contactByEmailConsentWording?: string;
        mortgageAdvisoryWantedWording?: string;
        userAuthenticationType?: 'ACCOUNT' | 'NONE'; // not used: 'DOUBLE_OPT_IN'
        userConsentType?: 'CHECKBOX';
    };
    partialHomeInformation: {
        "plotAvailable": boolean,
        "postalCode": string,
        "type": 'APARTMENT' | 'DUPLEX_HOUSE_BOTH' | 'DUPLEX_HOUSE_HALF' | 'MULTI_FAMILY_HOUSE' | 'SEMI_DETACHED_HOUSE' | 'SINGLE_FAMILY_HOUSE' | 'TERRACED_HOUSE_END' | 'TERRACED_HOUSE_MIDDLE' | 'TWO_FAMILY_HOUSE',
        // "usageType": "OWN_USE",
    },
}

export interface IMortagePerson {
        additionalMonthlyIncome: number;
        birthday: string;
        employedSince: string;
        monthlyNetIncomeInEuro: number;
}

export interface IMortageData {
    firstPerson: IMortagePerson,
    household: {
        equityTotalInEuro: number;
    };
    purchasePriceInEuro: number;
    secondPerson?: IMortagePerson;
    subtype: 'PURCHASE'; // | 'REFINANCE';
}

export interface IMortageResponse {
    displayConditions: {
        calculatedAt: string;
        effectiveInterestRateInPercent: number;
        fixedInterestPeriodInYears: number;
        fixedInterestRateInPercent: number;
        monthlyPaymentInEuro: number;
        offeringBank: string;
        rank: number;
    };
    passt: {
        financialProposalId: string;
        requestId: string;
    };
    scoring: {
        feasibilityScore: number;
        feasibilityScoreAsGrade: string;
        closingProbabilityScoreAsGrade: string;
    }
}

export interface ILeadResponse {
    campaign: string;
    chosenLeadCampaignId: string;
    consumerInterface: {
        name: string;
    };
    createdAt: string;
    dataContext: string;
    externalHomeId: string;
    homeId: string;
    id: string;
    keyword: string;
    leadConsumerGroupId: string;
    leadProviderGroupId: string;
    legal: {
        contactByEmailConsentWording: string;
        contactByPhoneConsentWording: string;
        dataProcessingAsDataProcessorAt: string;
        hasAccessToHomeDetails: boolean;
        hasReceivedHomecloudDataPrivacyNotes: boolean;
        hasReceivedPartnerDataPrivacyNotes: boolean;
        hasSignedBrokerageContract: boolean;
        homecloudDataPrivacyNotesWording: string;
        homecloudTermsCheckedAt: string;
        homecloudTermsWording: string;
        isContactByPhoneWanted: boolean;
        isDataProcessingAsDataProcessor: boolean;
        isHomecloudTermsChecked: boolean;
        isMortgageAdvisorDataForwardingChecked: boolean;
        isRealEstateDataForwardingChecked: boolean;
        mortgageAdvisorDataForwardingWording: string;
        partnerDataPrivacyNotesWording: string;
        realEstateDataForwardingCheckedAt: string;
        realEstateDataForwardingWording: string;
        receivedHomecloudDataPrivacyNotesAt: string;
        receivedPartnerDataPrivacyNotesAt: string;
    };
    mortgage: {
        displayConditions: IMortageResponse['displayConditions'];
        oneclick: {
            isOneClickQualified: boolean;
        };
    },
    scoring: {
        closingProbabilityScoreAsGrade: string;
        feasibilityScore: number;
        feasibilityScoreAsGrade: string;
        maximumOfferInEuro: number;
    },
    source: string;
    trackingId: string;
    type: string;
    updatedAt: string;
}


class LeadSmartApi {
    protected token: string = null;
    protected tokenExpires: number = null;
    protected LoadingCredentialsPromise: Promise<RequestResponse> | null = null;


    protected campaignId: string = null;


    public getHomeByExternalId = (externalId: string) => {
        return this.getToken().then((_token) => {
            return this.request('GET', `${API_URL}/homes/${externalId}`);
        });
    };

    public typeOfEmployment2employmentType = (type: IPersonFields['typeOfEmployment']): ILeadPerson['employmentType']  =>   {

        const mapping: Record<IPersonFields['typeOfEmployment'], ILeadPerson['employmentType']> = {
            'ANGESTELLTER': 'EMPLOYEE',
            'ARBEITER': 'WORKER',
            'BEAMTER': 'PUBLIC_SERVANT',
            'SELBSTSTAENDIGER': 'FREELANCER', // could also be SELF_EMPLOYED, but we use FREELANCER for simplicity
            'GESELLSCHAFTER': 'SELF_EMPLOYED', // could also be FREELANCER, but we use SELF_EMPLOYED for simplicity
            'RENTNER': 'RETIREE',
            'PENSIONAER': 'RETIREE',
            'STUDENT': 'UNEMPLOYED', // or could be FREELANCER, but we use UNEMPLOYED for simplicity
            'AZUBI': 'EMPLOYEE', // or could be WORKER, but we use EMPLOYEE for simplicity
            'HAUSMANN': 'STAY_AT_HOME_PARTNER',
            'ARBEITSLOSER': 'UNEMPLOYED'
            
        };
        if (mapping[type]) {
            return mapping[type];
        } else {
            console.warn('Unknown typeOfEmployment', type); 
            // default to EMPLOYEE
            return 'EMPLOYEE';
        }
    }

    public propertyType2PartialHomeInformationType = (type: IProperty['property_type_name']): ILeadData['partialHomeInformation']['type'] | undefined => {
        
        if (!type) {
            return undefined;
        }

        if (type.startsWith('apartment')) {
            return 'APARTMENT'; // default type
        }
        
        const houseMapping: Record<IPropertyTypeHouse, ILeadData['partialHomeInformation']['type']> = {
            'house': 'SINGLE_FAMILY_HOUSE',
            'house_bungalow': 'SINGLE_FAMILY_HOUSE',
            'house_farm': 'SINGLE_FAMILY_HOUSE',
            'house_multi_family': 'MULTI_FAMILY_HOUSE',
            'house_one_family': 'SINGLE_FAMILY_HOUSE',
            'house_other': undefined,
            'house_row': 'TERRACED_HOUSE_MIDDLE',
            'house_semi_detached': 'SEMI_DETACHED_HOUSE',
            'house_villa': 'SINGLE_FAMILY_HOUSE',
        }

        return houseMapping[type] as ILeadData['partialHomeInformation']['type'] || undefined
    }

    public createLead = (data: Pick<ILeadData, 'externalHomeId' | 'trackingId' | 'firstPerson' | 'household' | 'legal' | 'type'>): Promise<ILeadResponse> => {

        if (!this.campaignId) {
            return Promise.reject('No campaignId, make preflight request first!');
        }

        const addData: Omit<ILeadData, 'externalHomeId' | 'trackingId' | 'firstPerson' | 'household' | 'legal' | 'type' | 'subtype' | 'partialHomeInformation'> = {
            chosenLeadCampaignId: this.campaignId,
            campaign: "Wohnglueck-Exposee-Anfrage",
            source: "Impleco Wohnglück",
            keyword: "Wohnglueck-Finanzierungscheck-JetztPersoenlicheRateBerechnen",
            dataContext: isTestModus ? "TEST" : "REAL",
            secondPerson: undefined,
        }

        return this.getToken().then((token) => {
            return this.request('POST', `${API_URL}/leads`, { ...addData, ...data }).then((res) => {
                return res.getData();
            });
        });
    }


    public patchLead = (leadId: string, data: RecursivePartial<ILeadData>): Promise<ILeadResponse> => {
        return this.getToken().then((token) => {
            return this.request('PATCH', `${API_URL}/leads/${leadId}`, data).then((res) => {
                return res.getData();
            });
        });
    }

    public leadPreflight = (postalCode: string): Promise<IPreflightResponse> => {

        if (!postalCode) return Promise.reject('no postal code');

        const data = {
            "expectedNumberOfResults": 1,
            "lead": {
                "firstPerson": {
                    "address": {
                        postalCode
                    }
                }
            }
        }

        return this.getToken()
            .then((token) => {
                return this.request('POST', `${API_URL}/leads/preflight`, data)
                    .then((res) => {
                        const data = res.getData();
                        if (!data?.leadConsumers?.[0]?.campaignId) {
                            return Promise.reject('no campaignId');
                        }
                        this.campaignId = data.leadConsumers[0].campaignId;
                        return data;
                    });
            });

    };

    public getMortgage = (data: IMortageData): Promise<IMortageResponse> => {
        return this.getToken()
            .then((_token) => {
                return this.request('POST', `${API_URL}/suggestions/mortgage`, data)
                    .then((res) => {
                        return res.getData();
                    });
            });
    }


    protected getToken = (forceRenew = false): Promise<string> => {
        if (!forceRenew && this.token && this.tokenExpires - 1000 > Date.now()) {
            // token from class
            return Promise.resolve(this.token);
        } else {
            // token from local storage
            const savedToken: { token: string; tokenExpires: number } = LocalStorage.getItem('leadSmartToken');
            if (savedToken?.tokenExpires - 1000 > Date.now()) {
                this.token = savedToken.token;
                this.tokenExpires = savedToken.tokenExpires;
                return Promise.resolve(savedToken.token);
            } else {
                // token from API
                return this.getTokenFromApi(forceRenew)
                    .then((res) => {
                        const data: ILeadTokenResponse = res.getData();
                        this.token = data.access_token;
                        this.tokenExpires = Date.now() + data.expires_in * 1000;
                        LocalStorage.setItem('leadSmartToken', { token: this.token, tokenExpires: this.tokenExpires });
                        return Promise.resolve(this.token);
                    });
            }
        }
    };

    protected getTokenFromApi = (forceRenew = false): Promise<RequestResponse> => {
        if (this.LoadingCredentialsPromise === null) {
            this.LoadingCredentialsPromise = PropApiRequest.getRequest(CREDENTIALS_URL + (forceRenew ? '?force-renew=1' : ''))
                .then((res) => {
                    this.LoadingCredentialsPromise = null;
                    return res;
                })
                .catch((e) => {
                    console.error(e);
                    this.LoadingCredentialsPromise = null;
                    return Promise.reject(e);
                });
        }
        return this.LoadingCredentialsPromise;
    };

    protected request = (method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'OPTIONS', url: string, data?: any) => {
        return new Promise<RequestResponse>((resolve: (resp: RequestResponse) => void, reject: (resp: IRequestError) => void) => {
            const xhr = new XMLHttpRequest();
            xhr.open(method, url);
            xhr.onerror = (e: any) => {
                const resp = new RequestResponse(xhr.status, url);
                console.error('XHR Error:', xhr);
                let data = null;
                try {
                    data = JSON.parse(xhr.responseText);
                } catch (e) {
                    console.error(e);
                }
                reject({ ...resp, responseData: data });
            };

            xhr.ontimeout = () => {
                console.error('timeout for request', url);
            }

            xhr.onreadystatechange = () => {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    const resp = new RequestResponse(xhr.status, url);
                    if (xhr.status >= 200 && xhr.status <= 299) {
                        try {
                            resp.setData(JSON.parse(xhr.responseText));
                        } catch (e) {
                            resp.setData(xhr.responseText);
                        }
                        resolve(resp);
                    } else {
                        console.error('Request error', xhr.status, xhr.responseText, resp);
                        let data = null;
                        try {
                            data = JSON.parse(xhr.responseText);
                        } catch (e) {
                            console.error(e);
                        }
                        reject({ ...resp, responseData: data });
                    }
                }
            };

            xhr.setRequestHeader(useProxy ? 'x-authorization' : 'authorization', `Bearer ${this.token}`);
            xhr.setRequestHeader('cache-control', `no-cache`);
            xhr.setRequestHeader('content-type', `application/json`);
            xhr.setRequestHeader('X-TraceId', `dnz_${Date.now()}`);
            xhr.timeout = 30000;
            xhr.send(data ? JSON.stringify(data) : null);
        });
    };
}

export default new LeadSmartApi();
